import styled from "styled-components";
import { UserScheme, CoorporateScheme } from "client-v2";
import media from "styled-media-query";

import Home from "./section/Home";
import { ColorV2 } from "@adoptaunabuelo/react-components";

const navBarHeight = 72;
const marginBottom = 16;
const paddingTop = 40;
const paddingBottom = 24;
const navBarHeightMobile = 0;
const marginBottomMobile = 0;
const paddingTopMobile = 24;
const paddingBottomMobile = 0;
const MainContainer = styled.div`
	display: flex;
	align-items: center;
	height: var(--doc-height);
	width: calc(100vw - 160px);
	padding: 0px 80px;
	overflow: hidden;
	flex-direction: column;
	background-color: ${ColorV2.surface.background};
	${media.lessThan("medium")`
		width: 100vw;
		padding: 0px;
	`}
`;
const DataContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: row;
	width: 100%;
	max-width: 1200px;
	gap: 32px;
	${media.lessThan("medium")`
		flex-direction: column;
    `}
`;
const RightContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	max-width: 50%;
	justify-content: flex-end;
	${media.lessThan("medium")`
		display: none;
    `}
`;
const CentralContainer = styled.div`
	position: relative;
	display: flex;
	flex: 1;
	align-items: center;
	border-radius: 24px;
	flex-direction: column;
	overflow: hidden;
	min-height: calc(
		var(--doc-height) - ${navBarHeight}px - ${marginBottom}px -
			${paddingTop}px - ${paddingBottom}px
	);
	overflow: scroll;
	background-color: "transparent";
	${media.lessThan("medium")`
		padding: ${paddingTopMobile}px 24px ${paddingBottomMobile}px;
		min-height: calc(var(--doc-height) - ${navBarHeightMobile}px - ${marginBottomMobile}px - ${paddingTopMobile}px - ${paddingBottomMobile}px);
		max-height: calc(var(--doc-height) - ${navBarHeightMobile}px - ${marginBottomMobile}px  - ${paddingTopMobile}px - ${paddingBottomMobile}px);
	`}
`;
const CentralContainerView = styled.div`
	position: relative;
	display: flex;
	flex: 1;
	flex-direction: column;
	max-width: 100%;
	height: 100%;
	${media.lessThan("medium")`
		width: 100%;
    `}
`;
const BackgroundImage = styled.img`
	object-fit: contain;
	width: 100%;
	max-height: 100vh;
	object-position: bottom;
`;

const CheckoutCorporate = (props: Props) => {

	return (
		<MainContainer>
			<DataContainer>
				<CentralContainer>
					<CentralContainerView>
						{props.corporate && (
							<Home
								amount={props.nLetters ? props.nLetters : 0}
								corporate={props.corporate}
								onFinish={props.onFinish}
							/>
						)}
					</CentralContainerView>
				</CentralContainer>
				<RightContainer>
					<BackgroundImage
						src={require("../../assets/images/background/letter.webp")}
					/>
				</RightContainer>
			</DataContainer>
		</MainContainer>
	);
};
export default CheckoutCorporate;
export interface Props {
	corporate?: CoorporateScheme;
	nLetters?: number;
	prevLetter?: {
		content: string;
		grandpa: UserScheme;
	};
	onFinish: () => void;
}
